/* global FormData */

import axios from 'axios'
import { toast } from 'react-toastify'

import status from './status'
import Token from './Token'

export default class Client {
  apiUrl
  clientId
  token

  constructor(apiUrl: string, clientId: string) {
    this.apiUrl = apiUrl
    this.clientId = clientId
    this.token = new Token(this)
  }

  async request(request, retry = true) {
    const { method, endpoint, expectedStatusCodes, data } = request
    const params = {
      method,
      headers: { ...this.token.headers() },
      responseType: 'json',
    }

    if (data) {
      if (typeof FormData !== 'undefined' && data instanceof FormData) {
        params.data = data
      } else {
        params.data = data ? JSON.stringify(data) : undefined
        params.headers = {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          ...params.headers,
        }
      }
    }

    // FIXME: I have completely failed here as axios will throw an exceptio
    // as soon an error code is sent, which means that my error handling
    // down below won't ever be called. As we don't have tests for the
    // client now, I won't touch this, because it requires a lot of API
    // calling code to be altered. Fix it as soon there is enough time for
    // this.
    let response = null
    try {
      response = await axios(`${this.apiUrl}${endpoint}`, params)
    } catch (e) {
      if (
        this.token.credentials != null &&
        e.response &&
        e.response.status === status.HTTP_401_UNAUTHORIZED &&
        retry === true
      ) {
        console.info('The token has expired. Obtaining new...')
        await this.token.refreshToken()
        response = await this.request(request, false)
      } else if (
        e.response &&
        e.response.status >= 500 &&
        e.response.status <= 599
      ) {
        toast.error('Ett oväntat fel uppstod.')
        throw e
      } else {
        // Another error has occured, rethrow it.
        throw e
      }
    }
    if (
      (expectedStatusCodes && !expectedStatusCodes.includes(response.status)) ||
      response.status > 400
    ) {
      const statuses = (expectedStatusCodes || []).join(' ,')
      throw new Error(
        [
          'Received an unexpected response code (received: ',
          `${response.status}, expected ${statuses}).`,
        ].join('\n'),
      )
    }
    if (response.status === status.HTTP_400_BAD_REQUEST) {
      return { errors: response.data }
    }
    return { errors: null, data: response.data }
  }

  authenticate(username, password) {
    return this.token.get(username, password)
  }

  login(authResponse) {
    return this.token.getFromAuthResponse(authResponse);
  }

  logout(): void {
    this.token.revoke()
  }

  isAuthenticated(): boolean {
    return this.token.credentials != null
  }

  getRefreshToken(): ?string {
    const { credentials } = this.token
    return credentials ? credentials.refreshToken : null
  }

  async refreshToken() {
    if (this.token.credentials != null) {
      await this.token.refreshToken()
    }
  }
}



// WEBPACK FOOTER //
// ../source/api/Client.js